import React from 'react'
import { PrimaryButtonView } from 'components'

export default () => <PrimaryButtonView label="SKIP" />
